import { Input } from "@heroui/react";
import { useState } from "react";
import { CloseEyeIcon, EyeIcon } from "../../../assets/icons";

export const TextInput = ({
  value,
  onChange,
  disabled,
  label,
  type,
  name,
  required,
  maxLength,
  minLength,
  error,
  errorMsg,
  endContent,
  startContent,
  description,
  min,
  max,
  onKeyDown,
  placeholder,
  variant = "default", // "default" or "prominent" for edit mode
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const toggleVisibility = () => setIsVisible(!isVisible);
  const handleInputChange = (event) => {
    const { value } = event.target;
    if (type === "tel") {
      const sanitizedValue = value.replace(/[^0-9+()\- ]/g, "");
      onChange({ target: { name, value: sanitizedValue } });
    } else {
      onChange(event);
    }
  };

  const baseClasses = variant === "prominent"
    ? "shadow-none rounded-lg border-2 border-surface-border !bg-white hover:border-primary/40 data-[focus=true]:border-primary data-[focus=true]:ring-4 data-[focus=true]:ring-primary/15 transition-all duration-200"
    : "shadow-none rounded-md border border-surface-border hover:border-surface-border data-[focus=true]:border-primary/50 transition-colors";

  return (
    <Input
      label={label}
      labelPlacement="inside"
      type={type === "password" ? (isVisible ? "text" : "password") : type}
      size="sm"
      name={name}
      isDisabled={disabled}
      onWheel={(e) => e.target.blur()}
      value={value}
      onChange={disabled ? () => {} : handleInputChange}
      onKeyDown={onKeyDown}
      isRequired={required}
      maxLength={maxLength}
      minLength={minLength}
      isInvalid={error}
      errorMessage={errorMsg}
      description={description}
      min={min}
      max={max}
      classNames={{
        inputWrapper: `group-data-[disabled=true]:bg-mediumgrey/30 group-data-[disabled=true]:cursor-not-allowed pb-[2px] ${baseClasses}`,
        label:
          "scale-90 group-data-[focus=true]:-translate-y-2.5 group-data-[focus=true]:scale-75 group-data-[filled=true]:-translate-y-2.5 group-data-[filled=true]:scale-75 font-sans text-grey group-data-[focus=true]:text-primary",
        input: "font-sans text-sm placeholder:text-grey leading-4 pb-[4px]",
        errorMessage: "font-sans text-xs text-danger",
        description: "font-sans text-xs text-grey",
      }}
      endContent={
        type === "password" ? (
          <button
            type="button"
            className="my-auto cursor-pointer rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40"
            onClick={toggleVisibility}
            aria-label={isVisible ? "Hide password" : "Show password"}
            aria-pressed={isVisible}
          >
            {isVisible ? (
              <CloseEyeIcon className="text-grey" />
            ) : (
              <EyeIcon className="text-grey" />
            )}
          </button>
        ) : (
          endContent
        )
      }
      startContent={startContent}
      placeholder={placeholder}
    />
  );
};
